export default {
  title: {
    en: 'DONE?',
    ar: 'هل تمّ؟'
  },
  text: {
    en: 'If you delete this family member, you will have to create this Avatar from scratch!',
    ar: 'إذا حذفت هذه الشخصية من العائلة، سيتعين عليك إنشاء هذه الشخصية من البداية!'
  },
  confirm: {
    en: 'Delete',
    ar: 'محو'
  },
  cancel: {
    en: 'Back',
    ar: 'عودة'
  }
};
